import React from 'react';
import styled from 'styled-components';
import * as JStorage from '../../../JStorage';

import {Link} from 'gatsby';
import {Add} from '@styled-icons/ionicons-outline/Add';
import Theme from '../../../Theme';
import * as AppActions from '../../../AppActions';
import ClinicSearch from './ClinicSearch';
import ListSection from '../ListSection';
import CarouselSection from '../CarouselSection';
import {useOutlet} from 'reconnect.js';
import useArea from '../../../Hooks/useArea';

function Landing(props) {
  const [_landing] = useOutlet('landing');
  const {
    pageContext: {prebuiltSiteConfig},
  } = props;
  const {isPeople} = useArea();

  const landing = _landing || prebuiltSiteConfig.landing || {};
  const {carousel = [{}], bottom_links = []} = landing.custom_layout || {};

  return (
    <Wrapper>
      <div className="main">
        <section className="clinic">
          <ClinicSearch />
        </section>

        <CarouselSection
          className="carousel"
          items={carousel
            .filter((c) => c.public_area)
            .sort((a, b) => a.order - b.order)}
        />

        <ListSection
          className="list-1"
          title="衛教專區"
          route="/people/education"
          collection="health_education"
          color="#f59000"
          isPeople={isPeople}
          isNews={true}
        />
        <ListSection
          className="list-2"
          title="活動看板"
          route="/people/events/events"
          itemRoute="/people/events/content"
          routeName="活動快訊"
          category="民眾活動"
          collection="product"
          color="#f59000"
          isPeople={isPeople}
        />

        <ActivitiySection
          className="list-3"
          title="活動花絮"
          route="/people/events/gallery"
          collection="activity"
          color="#f59000"
        />
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: var(--topNavBarHeight);
  min-height: var(--contentMinHeight);
  background-color: var(--primaryBgcolor);

  & > .main {
    max-width: var(--contentMaxWidth);
    margin: 0px auto;
    padding: 40px 0;

    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;

    & > section.carousel {
      grid-column: span 2;
    }
  }

  @media (max-width: ${Theme.maxWidth}px) {
    & > .main {
      padding: 20px;
    }
  }

  @media (max-width: ${Theme.breakpoint}px) {
    & > .main {
      grid-template-columns: 1fr;
      & > section.carousel {
        grid-column: span 1;
        grid-row: 1;
      }
    }
  }
`;

function ActivitiySection({
  title,
  collection,
  route,
  itemRoute,
  className,
  color,
}) {
  const [records, setRecords] = React.useState([]);

  React.useEffect(() => {
    async function fetchData() {
      try {
        const resp = await JStorage.fetchDocuments(
          collection,
          {public_area: true},
          ['-start_date'],
          {offset: 0, limit: 3},
          null,
          {token: null},
        );
        setRecords(resp.results || []);
      } catch (e) {
        console.warn(e);
      }
    }

    fetchData();
  }, []);

  return (
    <SectionWrapper className={className}>
      <div className="header">
        <h2 style={{borderBottomColor: color}}>{title}</h2>
        <div style={{flex: 1}}></div>
        <Link to={route}>
          <Add size={30} color={color} />
        </Link>
      </div>
      <ul>
        {records.map((record) => (
          <li key={record.id}>
            <Link to={route + '?id=' + record.id}>
              <img src={record.images?.[0]?.url} alt="acticity-image" />
              {/* <div>{record.title}</div> */}
            </Link>
          </li>
        ))}
      </ul>
    </SectionWrapper>
  );
}

const SectionWrapper = styled.section`
  padding: 20px;
  border-radius: 6px;
  background-color: #fff;
  overflow: hidden;

  .header {
    display: flex;
    align-items: center;

    & > h2 {
      border-bottom-width: 2px;
      border-bottom-style: solid;
      padding-bottom: 5px;
    }
  }

  & > ul {
    list-style: none;
    position: relative;

    & > li {
      background-color: #fff;
      padding: 5px;
      position: absolute;
      top: 0;
      left: 0;
      box-shadow: 2px 2px 12px -4px #555;
      & img {
        width: 190px;
      }
      &:nth-child(1) {
        transform: translate(-10%, 20%) rotate(-20deg);
      }

      &:nth-child(2) {
        transform: translate(80%, 20%) rotate(15deg);
      }

      &:nth-child(3) {
        transform: translate(40%, 150%) rotate(5deg);
      }
    }
  }
`;

export default Landing;
